<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">宿舍床位表</span>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                    <div is="option" value="u">上</div>
                    <div is="option" value="d">下</div>
                </form-select>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-select v-model="vm.House" id="House" label="宿舍" required>
                    <slot name="house"></slot>
                </form-select>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.Room" id="Room" label="寢室" type="text" required></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-select v-model="vm.No" id="Job" label="床號" required>
                    <div is="option" v-for="o in 6" :key="o" :value="o">{{o}}</div>
                </form-select>
            </div>
            <div class="col-12">
                <form-input v-model="vm.Extension" id="Extension" label="分機" type="text"></form-input>
            </div>
            <div class="col-12">
                <form-input v-model="vm.StudentNo" id="StudentNo" label="學號" type="text" student required></form-input>
            </div>
            <div class="col-12">
                <studata type="StudentNo" vname="dormitoryDetail" :id="vm.StudentNo"></studata>
            </div>
        </div>
    </modal>
</template>

<script>
    import studata from '@/views/layout/_studata.vue';
    import { detail } from '@/views';

    export default detail({
        name: 'dormitoryDetail',
        api: '/api/dormitory/',
        components: { studata },
    });
</script>

<style>
</style>